import React from 'react'
import './SimpleBanner.scoped.sass'

export function SimpleBanner (props) {
  const {
    type = '',
    children
  } = props

  return (
    <div className={`simple-banner-container ${type}`}>
      {children}
    </div>
  )
}
